// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"Header_pattern-gradient__-30FV","header":"Header_header__M2zQ+","icon":"Header_icon__YCpdR","icon--sidebar":"Header_icon--sidebar__wGiMf"};